@if (!loading()) {
  <div id="53EF26D3-8C0A" [ngClass]="{'border-danger focus:outline-danger error': state() === 'error'}"
    class="w-full relative flex items-center justify-between h-[32px] border border-border-solid border-radius-8 dropshadow-xs transition-colors bg-background focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2 pr-[10px] cursor-pointer"
    (keydown)="input.focus(); markAsTouched()"
    (click)="input.select(); input.focus(); markAsTouched()">
    <div id="70F3F22A-41ED"
      #anchor class="flex items-center justify-center gap-1 text-muted-foreground h-full w-fit bg-muted-solid px-[10px] rounded-l-[8px] border-r-1 border-border-solid"
      (keydown)="showCountryList = true" (click)="showCountryList = true">
      <div id="DDCF91DC-C726" class="w-[20px] bg-flags-bg {{ flagsPosition[activeCountryObject.Region] }} bg-no-repeat bg-[length:5652px_15px]"></div>
      <i id="65B433C6-B54D" class="fi fi-rr-angle-small-down mt-auto"></i>
    </div>
    <input id="538F87C8-1336" #input type="text" [(ngModel)]="_value" [name]="name" [id]="id"
      [mask]="activeCountryObject.MobileMask" [placeholder]="activeCountryObject.MobileMask"
      (keyup)="setValue($event.target)" (blur)="barred()"
      class=" border-0 focus:ring-0 focus:outline-none appearance-none content-regular w-full leading-6 text-foreground text-center placeholder:text-center placeholder:text-muted-foreground
        disabled:opacity-50 bg-background focus:border-transparent bg-none placeholder:text-[14px] placeholder:font-open-sans placeholder:font-normal" />
    @if (telephoneTranslation()) {
    <nav id="65E3D7A7-8E9D"
    toggleElement [anchor]="anchor" [toggleByAnchor]="false" [show]="showCountryList" [closeInternalClick]="false" (showChange)="showCountryList = $event"
      class="absolute top-[32px] my-[4px] shadow-box-model z-30 w-fit text-foreground border border-border-solid border-radius-8 text-sm overflow-y-auto flex-1 shrink self-stretch basis-0 whitespace-nowrap content-semibold bg-background"
      [ngClass]="showCountryList ? 'visible' : 'hidden'">
      <lib-scroll-area [childItemHeight]="36" [scrollDirection]="'vertical'" [withBorder]="false" [withDivider]="true">
        @for (tel of telephoneTranslation(); track $index) {
        <button id="C7410893-DAD7" class="w-full cursor-pointer focus:outline-none p-2 flex items-center gap-2"
          [id]="tel.CountryDisplayName" (click)="selectCountry($event, tel)">
          <div id="9178A3E4-8DE0" class="flex items-center justify-center">
            <div id="7F1A9C45-6549"
              class="w-[20px] bg-flags-bg {{ flagsPosition[tel.Region] }} bg-no-repeat bg-[length:5652px_15px]">
            </div>
          </div>
          {{ tel.CountryDisplayName }}
          <p id="6FB8B8B1-067A" class="text-muted-foreground">+{{ tel.CountryCode }}</p>
        </button>
        }
      </lib-scroll-area>
    </nav>
    }
  </div>
  }
  @if (loading()) {
  <div class="w-full relative m-0 p-0 flex flex-col gap-y-0.5 -mb-[11px]">
    <div class="h-5 m-0 p-0" [ngStyle]="{ width: label.length / 2 + 'rem' }">
      <lib-skeleton-loader [theme]="{ height: '1rem' }"></lib-skeleton-loader>
    </div>
    <lib-skeleton-loader [theme]="{ height: '1.9rem' }"></lib-skeleton-loader>
  </div>
  }
  